import * as XLSX from 'xlsx';
import { getExcelColumns } from './getExcel.helpers';
import { createTXT } from './createTXT';
import { downloadZip } from '@/utils/downloadFile';

interface downloadAdvancedSearchResultsZipProps {
  suggestionsData: any[];
  searchType: string;
  selectedFilter: string;
  text: string;
  totalSearched: number;
  totalFound: number;
}

export const downloadAdvancedSearchResults = async ({
  suggestionsData,
  searchType,
  selectedFilter,
  text,
  totalSearched,
  totalFound,
}: downloadAdvancedSearchResultsZipProps) => {
  // 1. Build rows
  const rows =
    suggestionsData?.flatMap((item: any) => {
      const results = Array.isArray(item?.results) ? item.results.filter(Boolean) : [];
      const query = item?.query ?? item?.__query ?? item?.value ?? item?.label ?? '';

      return results.map((r: any) => ({
        ...r,
        __query: query,
      }));
    }) || [];

  // 2. Columns
  const columns = getExcelColumns(searchType, selectedFilter);

  // 3. Data formatted for Excel
  const dataForExcel = rows.map(row => {
    const excelRow: any = {};

    columns.forEach(col => {
      excelRow[col.header] = col.value(row, row.__query);
    });

    return excelRow;
  });

  // 4. Create Excel buffer
  const worksheet = XLSX.utils.json_to_sheet(dataForExcel);
  const workbook = XLSX.utils.book_new();

  XLSX.utils.book_append_sheet(workbook, worksheet, 'Results');

  const excelBuffer = XLSX.write(workbook, {
    bookType: 'xlsx',
    type: 'array',
  });

  // 5. Metadata TXT
  const metadataContent = createTXT({
    searchType,
    selectedFilter,
    text,
    totalSearched,
    totalFound,
  });

  // 6. Download ZIP
  await downloadZip({
    zipName: `advanced_search_${searchType.toLowerCase()}`,
    files: [
      { name: `advanced_search_results.xlsx`, content: excelBuffer },
      { name: `advanced_search_metadata.txt`, content: metadataContent },
    ],
  });
};
